export const sidebarItemClicked = "sidebar_item_clicked"; // Sidebar item selection
export const createNewAssessmentClicked = "create_new_assessment_clicked"; // New assessment creation click
export const assessmentsFilterApplied = "assessments_filter_applied"; // Assessment list filtering
export const assessmentReportClicked = "assessment_report_clicked"; // Assessment report viewing
export const assessmentEditClicked = "assessment_edit_clicked"; // Assessment editing
export const assessmentCloneClicked = "assessment_clone_clicked"; // Assessment duplication
export const assessmentDeleteClicked = "assessment_delete_clicked"; // Assessment deletion or cancellation
export const assessmentJourney = "assessment_journey"; // Assessment wizard progress
